import React from 'react';
import { useTranslation } from 'react-i18next';

import { ViewLayer, ViewSettings } from '../../../../../../viewer/view-settings';
import { LabelledContainer } from '../../../../labelled-container/labelled-container';
import { Slider } from '../../../../slider/slider';
import { useViewSettings } from './use-view-settings';

type Props = {
  layer: Exclude<ViewLayer, 'orthophoto'>;
};

/**
 * The opacity of the tiled model or the point cloud. The orthophoto's is in its own settings.
 */
const LayerOpacity = (props: Props) => {
  const { t } = useTranslation();
  const { opacity } = useViewSettings();

  return (
    <LabelledContainer
      noWrap={true}
      text={t('viewSettings.opacity.title', { ns: 'skyviewToolbar', value: opacity[props.layer] })}
    >
      <Slider
        max={1}
        min={0}
        step={0.05}
        value={opacity[props.layer]}
        onChange={(value) => ViewSettings.instance.setOpacity(props.layer, value)}
      />
    </LabelledContainer>
  );
};

export { LayerOpacity };
